export default __webpack_public_path__ + "static/media/sub_page_exhibitor.99469f65.svg";